"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _TimelineStatusStore = _interopRequireDefault(require("crm_ui/timeline/data/stores/TimelineStatusStore"));

var TimelineStatusDependency = {
  stores: [_TimelineStatusStore.default],
  deref: function deref() {
    return _TimelineStatusStore.default.get('timelineStatus');
  }
};
var _default = TimelineStatusDependency;
exports.default = _default;
module.exports = exports.default;